import Vue from 'vue';
import Vuetify from 'vuetify';
// import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xs: 631,
      sm: 884,
      md: 1280,
      lg: 1500,
    },
  },
  theme: {
    themes: {
      light: {
        // primary: '#5D1049',
        // secondary: '#E30425',
        // accent: '#720D5D',
        // error: '#F57C00',
        background:"#FFFFFF"
      },
    },
  },
});
